/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";

import Button, {
  BUTTON_COLORS,
  BUTTON_SIZES,
  BUTTON_VARIANTS
} from "@/components/Button/Button";
import Typography from "@mui/material/Typography";

import { ClearIcon, colors, EventIcon } from "@dotnet/telematics-design-system";

import { value } from "../styles/useDatePickerStyles";

interface PickerInputValueProps {
  displayValue: string;
  isPlaceholder: boolean;
  disabled?: boolean;
  hasClearableValue?: boolean;
  onClear?: (event: React.MouseEvent) => void;
}

const PickerInputValue = ({
  displayValue,
  isPlaceholder,
  disabled = false,
  hasClearableValue = false,
  onClear
}: PickerInputValueProps) => {
  return (
    <>
      <div
        css={css({
          display: "flex",
          alignItems: "center",
          gap: "8px",
          color: colors.textPlaceholder,
          overflow: "hidden",
          minWidth: 0,
          flex: 1
        })}
        data-testid="shared-date-picker-input-label"
      >
        <EventIcon style={{ width: "22px", height: "22px", flexShrink: 0 }} />

        <Typography
          variant="body2Medium"
          css={css({
            ...value,
            color: isPlaceholder ? colors.textPlaceholder : colors.textDark
          })}
        >
          {displayValue}
        </Typography>
      </div>

      {hasClearableValue && (
        <Button
          data-testid="date-picker-input-clear-btn"
          variant={BUTTON_VARIANTS.IconOnly}
          size={BUTTON_SIZES.Tiny}
          color={BUTTON_COLORS.White}
          onClick={onClear}
          icon={
            <ClearIcon
              css={css({
                width: "16px",
                height: "16px"
              })}
            />
          }
          css={css({ visibility: disabled ? "hidden" : "visible" })}
        />
      )}
    </>
  );
};

export default PickerInputValue;
